import { SET_USER, LOGOUT } from 'constants/actions';
import { type AppDispatch } from 'javascripts/store';
import { type SetUserAction } from 'javascripts/reducers/user';

function logoutUser() {
  return {
    type: LOGOUT,
  };
}

function setUserFromJson(): SetUserAction {
  const currentUser = window.gon.current_user_json;
  return {
    type: SET_USER,
    user: {
      ...currentUser,
      permissions: Object.values(currentUser.permissions).map((p) => p.value),
    },
  };
}

function logout() {
  return (dispatch: AppDispatch) => {
    dispatch(logoutUser());
    document.location.href = '/signout';
  };
}

export { setUserFromJson, logout };
